import { Component } from '@theme/component';

import { StandardEvents } from '@shopify/events';

import { DrawerOpenEvent } from '@theme/theme-drawer';

import { ThemeEvents } from '@theme/events';



const AVEYA_CART_CSS = "#cart-drawer[id=\"cart-drawer\"] .theme-drawer__dialog {\n  --theme-drawer-width: min(100vw, 480px);\n  width: var(--theme-drawer-width);\n  max-width: 100vw;\n  background: #fff;\n  color: #20201e;\n  font-family: Jost, var(--font-body--family, sans-serif);\n}\n#cart-drawer[id=\"cart-drawer\"] cart-drawer-component {\n  --aveya-accent: #880b51;\n  --aveya-line: #e6dfda;\n  --aveya-muted: #969696;\n  --aveya-summary: #faf4ee;\n}\n#cart-drawer[id=\"cart-drawer\"] .theme-drawer__header {\n  flex: 0 0 auto;\n  gap: 12px;\n  min-height: 0;\n  padding: 8px 26px;\n  border-bottom: 1px solid #ddd;\n  background: #f8f8f8;\n}\n#cart-drawer[id=\"cart-drawer\"] .theme-drawer__title {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  margin: 0;\n  font-family: inherit;\n  font-size: 25px;\n  line-height: 1.2;\n  font-weight: 500;\n  letter-spacing: -.6px;\n  text-transform: none;\n  color: #080808;\n}\n#cart-drawer[id=\"cart-drawer\"] .theme-drawer__badge {\n  display: inline;\n  width: auto;\n  min-width: 0;\n  height: auto;\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  aspect-ratio: auto;\n}\n#cart-drawer[id=\"cart-drawer\"] .theme-drawer__badge::before { content: '· '; }\n#cart-drawer[id=\"cart-drawer\"] .theme-drawer__close-button {\n  width: 44px;\n  height: 44px;\n  min-width: 44px;\n  min-height: 44px;\n  padding: 7px;\n  border: 0;\n  border-radius: 7px;\n  background: #ececec;\n  color: #000;\n}\n#cart-drawer[id=\"cart-drawer\"] .theme-drawer__close-button .svg-wrapper,\n#cart-drawer[id=\"cart-drawer\"] .theme-drawer__close-button svg { width: 28px; height: 28px; }\n#cart-drawer[id=\"cart-drawer\"] .mv-cm { flex-shrink: 0; margin: 0; color: inherit; font-family: inherit; }\n#cart-drawer[id=\"cart-drawer\"] .mv-cm__reserve { display: none !important; }\n#cart-drawer[id=\"cart-drawer\"] .mv-cm__body { padding: 0; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping {\n  padding: 11px 32px 14px;\n  border-bottom: 1px solid var(--aveya-line);\n  text-align: center;\n  background: #fff;\n}\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping p { margin: 0 0 10px; font-size: 16px; line-height: 1.4; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping__track {\n  position: relative;\n  height: 8px;\n  margin-right: 13px;\n  border-radius: 999px;\n  background: var(--aveya-accent);\n}\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping__tag {\n  position: absolute;\n  top: 50%;\n  right: -14px;\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--aveya-accent);\n  color: #fff;\n  transform: translateY(-50%);\n}\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping__tag svg { width: 18px; height: 18px; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__content { padding: 0; background: #fff; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__items { flex: 1 0 auto; padding: 0; background: #fff; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items { padding: 0; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__table { width: 100%; border-spacing: 0; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__items .cart-items__table-row {\n  position: relative;\n  grid-template-columns: 84px minmax(0, 1fr) 0;\n  column-gap: 20px;\n  row-gap: 3px;\n  margin: 0;\n  padding: 28px 26px 20px;\n  border-bottom: 1px solid var(--aveya-line);\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-items__table-row--full-width-variants {\n  grid-template-rows: repeat(4, min-content) auto;\n  grid-template-areas: 'media details details' 'media variants variants' 'media unit_price unit_price' 'media quantity quantity' 'error error error';\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-items__product-info { padding-right: 26px; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__title {\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -.4px;\n  color: #222;\n  text-transform: none;\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-items__variants-wrapper { color: var(--aveya-muted); font-size: 15px; line-height: 1.4; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__variants { margin: 0; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__variants-wrapper :is(dt, dd) { font: inherit; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__variants dt.visually-hidden {\n  position: static !important;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n  clip-path: none;\n  white-space: normal;\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-items__variants dt::after { content: ' '; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__unit-price-wrapper { color: #222; font-size: 18px; line-height: 1.25; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__unit-price-wrapper :is(span, bdi) { font-size: inherit; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__table-row--full-width-variants > .cart-items__price { display: none; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__media { align-self: start; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__media-container { aspect-ratio: 1; border-radius: 0; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__media-image { width: 100%; height: 100%; object-fit: contain; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__quantity { margin-top: 4px; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__quantity .quantity-selector {\n  display: grid;\n  grid-template-columns: 36px 44px 36px;\n  width: 118px;\n  min-width: 0;\n  height: 38px;\n  padding: 0;\n  overflow: hidden;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background: #fff;\n  color: #080808;\n}\n#cart-drawer[id=\"cart-drawer\"] .quantity-selector :is(button, input) {\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  height: 36px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  background: transparent;\n  color: inherit;\n  font-family: inherit;\n  font-size: 17px;\n  text-align: center;\n}\n#cart-drawer[id=\"cart-drawer\"] .quantity-selector input { border-inline: 1px solid #ddd; appearance: textfield; }\n#cart-drawer[id=\"cart-drawer\"] .quantity-selector input::-webkit-inner-spin-button { appearance: none; }\n#cart-drawer[id=\"cart-drawer\"] .quantity-selector .svg-wrapper { width: 14px; height: 14px; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__remove {\n  position: absolute;\n  top: 27px;\n  right: 19px;\n  width: 32px;\n  height: 36px;\n  min-height: 0;\n  padding: 6px;\n  border: 0;\n  background: transparent;\n  color: #6d7b83;\n  box-shadow: none;\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary {\n  --cart-drawer-summary-padding: 24px;\n  flex: 0 0 auto;\n  align-items: stretch;\n  gap: 12px;\n  width: 100%;\n  margin-top: auto;\n  padding: 24px 26px max(12px, env(safe-area-inset-bottom));\n  border-top: 1px solid #e1d8d1;\n  background: var(--aveya-summary);\n  mask-image: none;\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary .cart-totals { gap: 0; padding: 0; border: 0; width: 100%; }\n#cart-drawer[id=\"cart-drawer\"] .cart-totals__container { gap: 0; border: 0; }\n#cart-drawer[id=\"cart-drawer\"] .cart-totals__original-container:empty { display: none; }\n#cart-drawer[id=\"cart-drawer\"] .cart-totals__total {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  color: #080808;\n  font-family: inherit;\n  font-weight: 400;\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-totals__total :is(.cart-totals__total-label, .cart-totals__total-value) { font-family: inherit; font-size: 23px; font-weight: 400; line-height: 1.3; }\n#cart-drawer[id=\"cart-drawer\"] .cart-totals__tax-note { display: none; }\n#cart-drawer[id=\"cart-drawer\"] .cart__ctas { margin: 0; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary button[name='checkout'] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 62px;\n  padding: 15px 12px;\n  border: 0;\n  border-radius: 9px;\n  background: var(--aveya-accent);\n  color: #fff;\n  box-shadow: none;\n  font-family: inherit;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.25;\n  letter-spacing: 0;\n  text-transform: none;\n}\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary button[name='checkout'] .button-text { font: inherit; letter-spacing: inherit; text-transform: none; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary button[name='checkout']:hover { background: #700842; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary button[name='checkout']:disabled { opacity: .5; cursor: not-allowed; }\n#cart-drawer[id=\"cart-drawer\"] :is(button, a, input):focus-visible { outline: 2px solid var(--aveya-accent); outline-offset: 3px; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-reassurance { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 8px 16px; margin: -3px 0 -3px; color: #62615e; font-size: 13px; line-height: 1.4; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-reassurance > span { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-reassurance svg { flex-shrink: 0; width: 18px; height: 18px; color: var(--aveya-accent); }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-payments { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 6px; width: 100%; margin: 0; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-payments > span { display: flex; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-payments svg { width: 32px; height: 21px; }\n@media (max-width: 389px) {\n  #cart-drawer[id=\"cart-drawer\"] .theme-drawer__header { padding: 12px 18px; }\n  #cart-drawer[id=\"cart-drawer\"] .theme-drawer__title { font-size: 23px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping { padding-inline: 24px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping p { font-size: 14px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer__items .cart-items__table-row { grid-template-columns: 68px minmax(0, 1fr) 0; column-gap: 14px; padding: 24px 18px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__remove { right: 10px; top: 21px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__title { font-size: 15px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__variants-wrapper { font-size: 14px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary { padding-inline: 18px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary button[name='checkout'] { font-size: 18px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-reassurance { gap: 6px 12px; font-size: 12px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-payments { gap: 5px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-payments svg { width: 28px; height: 18px; }\n}\n@media (max-width: 350px) {\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-payments { gap: 4px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-payments svg { width: 24px; height: 16px; }\n}\n@media (max-height: 650px) {\n  #cart-drawer[id=\"cart-drawer\"] .theme-drawer__header { padding-block: 8px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping { padding-block: 8px 16px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-shipping p { margin-bottom: 10px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary { gap: 8px; padding-block: 12px max(10px, env(safe-area-inset-bottom)); }\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer__summary button[name='checkout'] { min-height: 50px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-reassurance { margin-bottom: 0; }\n}\n\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .theme-drawer__header { justify-content: space-between; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .theme-drawer__header > [data-aveya-empty-heading] { margin-right: auto; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .cart-drawer__content { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0; flex: 1; width: 100%; min-height: 100%; padding: 40px 26px 56px; text-align: center; background: #fff; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .cart-drawer__content > .theme-drawer__title { display: block; width: 100%; margin: 24px 0 12px; font-size: 25px; line-height: 1.3; font-weight: 500; letter-spacing: -.5px; text-align: center; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .cart-drawer__items { flex: 0 0 auto; width: 100%; padding: 0; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__wrapper--drawer-empty { display: flex; flex-direction: column; align-items: center; gap: 0; width: 100%; max-width: 380px; margin: 0 auto; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__wrapper--drawer-empty > p { margin: 0; color: #70696c; font-family: inherit; font-size: 15px; line-height: 1.6; text-align: center; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__wrapper--drawer-empty > p a { color: #880b51; text-decoration: underline; text-underline-offset: 3px; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__empty-button { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 58px; height: auto; margin: 26px 0 0; padding: 16px 20px; border: 0; border-radius: 9px; background: #880b51; color: #fff; font-family: inherit; font-size: 18px; font-weight: 500; line-height: 1.3; letter-spacing: 0; text-transform: none; text-decoration: none; box-shadow: none; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__empty-button .button-text { font: inherit; letter-spacing: inherit; text-transform: none; }\n#cart-drawer[id=\"cart-drawer\"] .cart-items__empty-button:hover { background: #700842; color: #fff; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-empty-icon { display: grid; place-items: center; flex: 0 0 auto; width: 100px; height: 100px; border: 1px solid #ead1dc; border-radius: 50%; background: #faf4ee; color: #880b51; }\n#cart-drawer[id=\"cart-drawer\"] .aveya-cart-empty-icon svg { width: 46px; height: 46px; }\n#cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty :is(.mv-cm, .cart-drawer__summary) { display: none; }\n@media (max-width: 389px) {\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .cart-drawer__content { padding: 30px 20px 44px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .cart-drawer__content > .theme-drawer__title { font-size: 23px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__wrapper--drawer-empty > p { font-size: 14px; }\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__empty-button { font-size: 17px; }\n}\n@media (max-height: 600px) {\n  #cart-drawer[id=\"cart-drawer\"] .cart-drawer--empty .cart-drawer__content { justify-content: flex-start; min-height: 0; padding-block: 24px; }\n  #cart-drawer[id=\"cart-drawer\"] .aveya-cart-empty-icon { width: 76px; height: 76px; }\n}\n\n/* Mobile thumbnail sizing: keep the existing 84px / 68px grid columns. */\n@media (max-width: 749px) {\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__media-container {\n    display: block;\n    width: 84px;\n    height: 84px;\n  }\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__media-image {\n    display: block;\n  }\n}\n@media (max-width: 389px) {\n  #cart-drawer[id=\"cart-drawer\"] .cart-items__media-container {\n    width: 68px;\n    height: 68px;\n  }\n}\n";

const AVEYA_UPSELL_CSS = `
@media (max-width: 749px) {
  #cart-drawer[id="cart-drawer"] .cart-items__table-row.cart-items__nested-line .cart-items__media {
    width: 100%;
    justify-self: stretch;
  }
}

#cart-drawer[id="cart-drawer"] .theme-drawer__dialog,
#cart-drawer[id="cart-drawer"] cart-drawer-component,
#cart-drawer[id="cart-drawer"] .cart-drawer__summary,
#cart-drawer[id="cart-drawer"] .cart-totals,
#cart-drawer[id="cart-drawer"] .cart-totals__container,
#cart-drawer[id="cart-drawer"] .cart-totals__total {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
#cart-drawer[id="cart-drawer"] .theme-drawer__dialog,
#cart-drawer[id="cart-drawer"] cart-drawer-component {
  overflow-x: hidden;
  overscroll-behavior-x: none;
  touch-action: pan-y;
}
#cart-drawer[id="cart-drawer"] .cart-drawer__summary {
  -webkit-mask-image: none !important;
  mask-image: none !important;
  opacity: 1 !important;
}
#cart-drawer[id="cart-drawer"] .theme-drawer__dialog,
#cart-drawer[id="cart-drawer"] cart-drawer-component,
#cart-drawer[id="cart-drawer"] .cart-drawer,
#cart-drawer[id="cart-drawer"] .cart-drawer__content,
#cart-drawer[id="cart-drawer"] .cart-drawer__items,
#cart-drawer[id="cart-drawer"] .cart-drawer__summary {
  -webkit-mask: none !important;
  mask: none !important;
  -webkit-mask-image: none !important;
  mask-image: none !important;
}
#cart-drawer[id="cart-drawer"] .cart-drawer__summary::before,
#cart-drawer[id="cart-drawer"] .cart-drawer__summary::after,
#cart-drawer[id="cart-drawer"] .theme-drawer__dialog::after,
#cart-drawer[id="cart-drawer"] cart-drawer-component::after,
#cart-drawer[id="cart-drawer"] .cart-drawer::after,
#cart-drawer[id="cart-drawer"] .cart-drawer__content::after,
#cart-drawer[id="cart-drawer"] .cart-drawer__items::after {
  display: none !important;
  content: none !important;
  background: none !important;
}
#cart-drawer[id="cart-drawer"] :is(.aveya-cart-reassurance, .aveya-cart-payments, .aveya-cart-payments > span, .aveya-cart-payments svg) {
  opacity: 1 !important;
  filter: none !important;
  -webkit-mask-image: none !important;
  mask-image: none !important;
}
#cart-drawer[id="cart-drawer"] .cart-totals__total {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: baseline;
  gap: 8px;
  width: 100%;
}
#cart-drawer[id="cart-drawer"] .aveya-cart-free-shipping {
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  justify-self: start;
  gap: 5px;
  padding: 4px 10px;
  overflow: hidden;
  border: 1px solid #bfe1c8;
  border-radius: 999px;
  background: #eaf7ed;
  color: #28733d;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#cart-drawer[id="cart-drawer"] .aveya-cart-free-shipping svg { flex: 0 0 auto; width: 15px; height: 15px; }
#cart-drawer[id="cart-drawer"] .cart-totals__total-label,
#cart-drawer[id="cart-drawer"] .cart-totals__total-value { min-width: 0; white-space: nowrap; }
#cart-drawer[id="cart-drawer"] .cart-totals__total-value {
  display: inline-flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 7px;
}
#cart-drawer[id="cart-drawer"] .aveya-cart-original-total {
  color: #756d70;
  font-size: 15px;
  font-weight: 400;
  text-decoration: line-through;
  text-decoration-thickness: 1px;
}
#cart-drawer[id="cart-drawer"] .aveya-cart-reviews {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  padding: 12px 18px;
  border-bottom: 1px solid var(--aveya-line);
  box-sizing: border-box;
  background: #fff;
  color: #40383c;
  font-family: inherit;
}
#cart-drawer[id="cart-drawer"] .aveya-cart-reviews__stars { display: inline-flex; flex: 0 0 auto; gap: 3px; }
#cart-drawer[id="cart-drawer"] .aveya-cart-reviews__star {
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #00b67a;
  color: #fff;
  font-size: 17px;
  line-height: 1;
}
#cart-drawer[id="cart-drawer"] .aveya-cart-reviews__star--partial {
  background: linear-gradient(90deg, #00b67a 70%, #d9e1df 70%);
}
#cart-drawer[id="cart-drawer"] .aveya-cart-reviews__text {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#cart-drawer[id="cart-drawer"] .aveya-cart-reviews__text strong { font-weight: 600; }
@media (max-width: 389px) {
  #cart-drawer[id="cart-drawer"] .aveya-cart-free-shipping { padding-inline: 7px; font-size: 11px; }
  #cart-drawer[id="cart-drawer"] .cart-totals__total :is(.cart-totals__total-label, .cart-totals__total-value) { font-size: 19px; }
  #cart-drawer[id="cart-drawer"] .aveya-cart-original-total { font-size: 12px; }
  #cart-drawer[id="cart-drawer"] .aveya-cart-reviews { gap: 7px; padding-inline: 12px; }
  #cart-drawer[id="cart-drawer"] .aveya-cart-reviews__stars { gap: 2px; }
  #cart-drawer[id="cart-drawer"] .aveya-cart-reviews__star { width: 19px; height: 19px; font-size: 15px; }
  #cart-drawer[id="cart-drawer"] .aveya-cart-reviews__text { font-size: 14px; }
}
`;

const AVEYA_REVIEWS_HTML = '<div class="aveya-cart-reviews" data-aveya-reviews role="img" aria-label="Note de 4,7 sur 5, plus de 8 000 clientes"><span class="aveya-cart-reviews__stars" aria-hidden="true"><span class="aveya-cart-reviews__star">★</span><span class="aveya-cart-reviews__star">★</span><span class="aveya-cart-reviews__star">★</span><span class="aveya-cart-reviews__star">★</span><span class="aveya-cart-reviews__star aveya-cart-reviews__star--partial">★</span></span><span class="aveya-cart-reviews__text"><strong>4,7/5</strong> · plus de 8 000 clientes</span></div>';

const AVEYA_FREE_SHIPPING_HTML = '<span class="aveya-cart-free-shipping" data-aveya-free-shipping><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>Livraison offerte</span>';

const AVEYA_REASSURANCE_HTML = "<span><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M12 3 20 6v5c0 5-3.4 8.3-8 10-4.6-1.7-8-5-8-10V6l8-3Z\"/><path d=\"m8.5 12 2.2 2.2 4.8-5\"/></svg>Garantie satisfait ou remboursé pendant 90 jours</span>";



/**

 * A custom element that manages cart drawer behavior within a `<theme-drawer>`.

 *

 * Dialog lifecycle (open/close, squeeze, history, animations) is owned by `<theme-drawer>`.

 * The `cart:view` event is auto-dispatched by `CartItemsComponent` via the

 * `view-event-trigger="dialog"` attribute (see `snippets/cart-items-component.liquid`).

 * Cart count announcements are owned by `<header-actions>`.

 * This component handles the remaining cart-specific concerns: auto-open on add-to-cart,

 * sticky summary layout, and the installments CTA close-on-click.

 *

 * @extends {Component}

 */

class CartDrawerComponent extends Component {

  /** @type {number} */

  #summaryThreshold = 0.5;



  /** @type {import('@theme/theme-drawer').ThemeDrawer | null} */

  get #themeDrawer() {

    return /** @type {import('@theme/theme-drawer').ThemeDrawer | null} */ (this.closest('theme-drawer'));

  }



  /** @type {HTMLDialogElement | null} */

  get #dialog() {

    return this.closest('dialog');

  }



  connectedCallback() {

    super.connectedCallback();

    this.#startAveyaOffer();

    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);

    this.#themeDrawer?.addEventListener(DrawerOpenEvent.eventName, this.#handleDrawerOpen);

    this.addEventListener(ThemeEvents.cartSectionRestored, this.#handleCartSectionRestored);



    // The restore path sets [open] before this module loads, so the

    // theme-drawer:open event will have already fired. Use the attribute

    // check so this works even before <theme-drawer> upgrades.

    if (this.#themeDrawer?.hasAttribute('open')) {

      this.#handleDrawerOpen();

    }

  }



  disconnectedCallback() {

    super.disconnectedCallback();

    this.#offerObserver?.disconnect();

    cancelAnimationFrame(this.#offerFrame);

    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);

    this.#themeDrawer?.removeEventListener(DrawerOpenEvent.eventName, this.#handleDrawerOpen);

    this.removeEventListener(ThemeEvents.cartSectionRestored, this.#handleCartSectionRestored);

  }



  /**

   * Recomputes the sticky summary after a back/forward cache restore re-renders the cart items.

   *

   * On viewports at or above 990px an open drawer survives a navigation and is reopened during

   * parsing (see the restore script in `snippets/theme-drawer.liquid`), so no open event fires

   * on the way back and the measurement taken before the shopper left is the one still applied.

   * An empty drawer measured as unpinned would keep the checkout CTA scrolling away once the

   * restore fills it with line items.

   */

  #handleCartSectionRestored = () => {

    requestAnimationFrame(() => this.#updateStickyState());

  };



  /**

   * Handles the theme-drawer opening — updates sticky state and wires up the installments CTA.

   */

  #handleDrawerOpen = () => {

    this.#updateStickyState();



    // Close cart drawer when installments CTA is clicked to avoid overlapping dialogs.

    // Re-queried on every open so it survives cart content re-renders that

    // replace the shopify-payment-terms shadow root.

    customElements.whenDefined('shopify-payment-terms').then(() => {

      const cta = this.querySelector('shopify-payment-terms')?.shadowRoot?.querySelector('#shopify-installments-cta');

      cta?.addEventListener('click', () => this.#themeDrawer?.close(), { once: true });

    });

  };



  /**

   * @param {import('@shopify/events').CartLinesUpdateEvent} event

   */

  #handleCartLinesUpdate = (event) => {

    const shouldAutoOpen = this.hasAttribute('auto-open') && event.action === 'add' && !this.#themeDrawer?.isOpen;



    // When the event originates inside an open MODAL <dialog> (e.g. quick-add),

    // defer the auto-open until that dialog's native `close` fires so its focus

    // restoration runs first — otherwise we'd capture the wrong

    // `#previouslyFocused`. Non-modal dialogs (e.g. the hotspot preview) don't

    // close on add and don't move focus, so `:modal` excludes them.

    const sourceModal = /** @type {HTMLDialogElement | null} */ (

      event.target instanceof Element ? event.target.closest('dialog:modal') : null

    );



    if (shouldAutoOpen && !sourceModal && !this.#isCartEmpty()) {

      this.#themeDrawer?.open();

    }



    event.promise

      ?.then(({ detail }) => {

        const settle = () => requestAnimationFrame(() => this.#updateStickyState());



        if (!shouldAutoOpen || detail?.didError) {

          settle();

          return;

        }



        const openAndSettle = () => {

          if (!this.#themeDrawer?.isOpen) this.#themeDrawer?.open();

          settle();

        };



        if (sourceModal?.open) {

          sourceModal.addEventListener('close', openAndSettle, { once: true });

        } else {

          openAndSettle();

        }

      })

      .catch((error) => {

        if (error?.name !== 'AbortError') console.warn('[cart-drawer] Event promise rejected:', error);

      });

  };





  #offerObserver;

  #offerFrame = 0;



  #observeAveyaCart() {

    this.#offerObserver?.observe(this, {

      childList: true,

      subtree: true,

      characterData: true,

      attributes: true,

      attributeFilter: ['view-event-payload'],

    });

  }



  #startAveyaOffer() {

    let style = document.getElementById('aveya-cart-drawer-styles');

    if (!style) {

      style = document.createElement('style');

      style.id = 'aveya-cart-drawer-styles';

      document.head.append(style);

    }

    const cartCss = AVEYA_CART_CSS + AVEYA_UPSELL_CSS;
    if (style.textContent !== cartCss) style.textContent = cartCss;

    this.#offerObserver = new MutationObserver(() => this.#scheduleAveyaCart());

    this.#observeAveyaCart();

    this.#scheduleAveyaCart();

  }



  #scheduleAveyaCart = () => {

    cancelAnimationFrame(this.#offerFrame);

    this.#offerFrame = requestAnimationFrame(() => this.#renderAveyaOffer());

  };



  #setAveyaText(element, text) {

    if (element && element.textContent !== text) element.textContent = text;

  }



  #formatAveyaMoney(amount, currency) {

    const options = { style: 'currency', currency };

    const formatted = new Intl.NumberFormat('fr-FR', options).format(amount);

    return currency === 'EUR' ? formatted.replace(/[\u00a0\u202f]€/u, '€') : formatted;

  }



  #parseAveyaMoney(value) {

    if (typeof value !== 'string') return NaN;

    return Number.parseFloat(

      value.replace(/[\s\u00a0\u202f€]/gu, '').replace(/[^0-9,.-]/gu, '').replace(',', '.'),

    );

  }



  #getAveyaKachingOriginalAmount(currentAmount) {

    const rows = [...this.querySelectorAll('.cart-items__table-row--full-width-variants[data-key]')];

    const items = rows.map((row) => {

      const title = row.querySelector('.cart-items__title')?.textContent?.replace(/\s+/gu, ' ').trim().toLocaleLowerCase('fr');

      const wrapper = row.querySelector('.cart-items__unit-price-wrapper');

      const currentPriceNode = [...(wrapper?.querySelectorAll('bdi') || [])].find(

        (node) => !node.closest('s, del, .compare-at-price, .cart-items__compare-price, [data-compare-at-price]'),

      ) || wrapper?.querySelector('bdi');

      const unitPrice = this.#parseAveyaMoney(currentPriceNode?.textContent || '');

      const quantity = Number(row.querySelector('.quantity-selector input')?.value || 1);

      const isOffer = /offert|offerte|gratuit|gratuite|cadeau/iu.test(row.textContent || '') || unitPrice <= 0.01;

      return { title, unitPrice, quantity, isOffer };

    }).filter((item) => item.title && Number.isFinite(item.unitPrice) && Number.isFinite(item.quantity));



    let discount = 0;

    for (const offer of items.filter((item) => item.isOffer)) {

      const paidMatch = items

        .filter((item) => item.title === offer.title && item.unitPrice > offer.unitPrice)

        .sort((left, right) => left.unitPrice - right.unitPrice)[0];

      if (paidMatch) discount += (paidMatch.unitPrice - offer.unitPrice) * offer.quantity;

    }

    return discount > 0 ? currentAmount + discount : null;

  }



  #getAveyaOriginalAmount(cart, currentAmount) {

    const kachingOriginal = this.#getAveyaKachingOriginalAmount(currentAmount);

    const kachingDiscount = Number.isFinite(kachingOriginal) ? kachingOriginal - currentAmount : 0;

    const ajaxOriginal = Number(cart?.original_total_price);

    if (Number.isFinite(ajaxOriginal) && ajaxOriginal / 100 > currentAmount) {

      return ajaxOriginal / 100 + kachingDiscount;

    }



    for (const candidate of [cart?.cost?.subtotalAmount?.amount, cart?.originalTotalAmount?.amount, cart?.originalTotalPrice?.amount]) {

      const value = Number(candidate);

      if (Number.isFinite(value) && value > currentAmount) return value + kachingDiscount;

    }



    const ajaxDiscount = Number(cart?.total_discount);

    if (Number.isFinite(ajaxDiscount) && ajaxDiscount > 0) {

      return currentAmount + ajaxDiscount / 100 + kachingDiscount;

    }



    if (Array.isArray(cart?.items)) {

      const original = cart.items.reduce((sum, item) => {

        const linePrice = Number(item?.original_line_price);

        return Number.isFinite(linePrice) ? sum + linePrice : sum;

      }, 0) / 100;

      if (original > currentAmount) return original + kachingDiscount;

    }



    const rawLines = cart?.lines;

    const lines = Array.isArray(rawLines)

      ? rawLines

      : Array.isArray(rawLines?.nodes)

        ? rawLines.nodes

        : Array.isArray(rawLines?.edges)

          ? rawLines.edges.map((edge) => edge?.node).filter(Boolean)

          : [];

    let discountTotal = 0;

    for (const line of lines) {

      const rawAllocations = line?.discountAllocations;

      const allocations = Array.isArray(rawAllocations)

        ? rawAllocations

        : Array.isArray(rawAllocations?.nodes)

          ? rawAllocations.nodes

          : Array.isArray(rawAllocations?.edges)

            ? rawAllocations.edges.map((edge) => edge?.node).filter(Boolean)

            : [];

      for (const allocation of allocations) {

        const value = Number(allocation?.discountedAmount?.amount ?? allocation?.amount?.amount);

        if (Number.isFinite(value) && value > 0) discountTotal += value;

      }

    }

    if (discountTotal > 0) return currentAmount + discountTotal + kachingDiscount;

    return kachingOriginal;

  }



  #renderAveyaOffer() {

    if (!this.isConnected) return;

    this.#offerObserver?.disconnect();

    try {

      if (this.#isCartEmpty()) {

        const header = this.querySelector('.cart-drawer--empty .theme-drawer__header');

        if (header && !header.querySelector('.theme-drawer__title')) {

          const title = document.createElement('span');

          title.className = 'theme-drawer__title';

          title.dataset.aveyaEmptyHeading = '';

          title.textContent = 'Mon Panier';

          header.prepend(title);

        }

        const content = this.querySelector('.cart-drawer--empty .cart-drawer__content');

        if (content && !content.querySelector('[data-aveya-empty-icon]')) {

          const icon = document.createElement('div');

          icon.className = 'aveya-cart-empty-icon';

          icon.dataset.aveyaEmptyIcon = '';

          icon.setAttribute('aria-hidden', 'true');

          icon.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16h24l3 26H9l3-26Z"/><path d="M17 18v-7a7 7 0 0 1 14 0v7"/></svg>';

          content.prepend(icon);

        }

        this.#updateStickyState();

        return;

      }

      this.querySelector('[data-aveya-empty-heading]')?.remove();

      this.querySelector('[data-aveya-empty-icon]')?.remove();

      const items = this.querySelector('cart-items-component');

      if (!items) return;

      let cart;

      try {

        cart = JSON.parse(items.getAttribute('view-event-payload') || '{}').cart;

      } catch {}

      const quantity = Number(cart?.totalQuantity ?? this.querySelector('[ref="cartItemCount"]')?.textContent?.trim());

      if (!Number.isFinite(quantity) || quantity < 1) return;

      for (const row of this.querySelectorAll('.cart-items__table-row--full-width-variants[data-key]')) {

        for (const price of row.querySelectorAll('.cart-items__unit-price-wrapper bdi')) {

          const currency = cart?.cost?.totalAmount?.currencyCode;

          if (currency === 'EUR' && price.textContent.includes('€')) {

            this.#setAveyaText(price, `${price.textContent.replace(/€|EUR/g, '').trim()}€`);

          }

        }

      }



      const title = this.querySelector('.theme-drawer__header .theme-drawer__title');

      if (title) {

        const textNode = [...title.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());

        if (textNode && textNode.textContent !== 'Mon Panier ') textNode.textContent = 'Mon Panier ';

        const badge = title.querySelector('.theme-drawer__badge');

        this.#setAveyaText(badge, String(quantity));

      }



      let body = this.querySelector('.mv-cm__body');

      if (!body) {

        let container = this.querySelector('.mv-cm');

        if (!container) {

          container = document.createElement('div');

          container.className = 'mv-cm';

          this.querySelector('.theme-drawer__header')?.after(container);

        }

        body = document.createElement('div');

        body.className = 'mv-cm__body';

        container.append(body);

      }

      if (!body.querySelector('[data-aveya-reviews]')) body.innerHTML = AVEYA_REVIEWS_HTML;



      const summary = this.querySelector('.cart-drawer__summary');

      if (!summary) return;

      const totalRow = summary.querySelector('.cart-totals__total');

      if (totalRow && !totalRow.querySelector('[data-aveya-free-shipping]')) {

        totalRow.insertAdjacentHTML('afterbegin', AVEYA_FREE_SHIPPING_HTML);

      }

      this.#setAveyaText(summary.querySelector('.cart-totals__total-label'), 'Total');

      const total = summary.querySelector('.cart-totals__total-value');

      const amount = Number(cart?.cost?.totalAmount?.amount);

      const currency = cart?.cost?.totalAmount?.currencyCode;

      let money = total?.textContent?.trim();

      if (Number.isFinite(amount) && typeof currency === 'string' && /^[A-Z]{3}$/.test(currency)) {

        money = this.#formatAveyaMoney(amount, currency);

        this.#setAveyaText(total?.querySelector('bdi') || total, money);

        const originalAmount = this.#getAveyaOriginalAmount(cart, amount);

        let original = total?.querySelector('[data-aveya-original-total]');

        if (Number.isFinite(originalAmount) && originalAmount > amount) {

          if (!original) {

            original = document.createElement('s');

            original.className = 'aveya-cart-original-total';

            original.dataset.aveyaOriginalTotal = '';

            total?.prepend(original);

          }

          this.#setAveyaText(original, this.#formatAveyaMoney(originalAmount, currency));

        } else {

          original?.remove();

        }

      }

      const checkout = summary.querySelector('button[name="checkout"]');

      if (checkout && money) {

        let label = checkout.querySelector('.button-text');

        if (!label) {

          label = document.createElement('span');

          label.className = 'button-text';

          checkout.append(label);

        }

        this.#setAveyaText(label, 'PAIEMENT SÉCURISÉ');

      }



      summary.querySelector('[data-aveya-guarantee]')?.remove();

      if (!summary.querySelector('[data-aveya-reassurance]')) {

        const reassurance = document.createElement('div');

        reassurance.className = 'aveya-cart-reassurance';

        reassurance.dataset.aveyaReassurance = '';

        reassurance.innerHTML = AVEYA_REASSURANCE_HTML;

        summary.append(reassurance);

      }

      if (!summary.querySelector('[data-aveya-payments]')) {

        const template = document.getElementById('aveya-cart-payments-template');

        if (template instanceof HTMLTemplateElement) {

          summary.append(template.content.cloneNode(true));

        } else {

          const source = document.querySelector('ul.a2i, .list-payment, .payment-icons');

          if (source?.querySelector('svg')) {

            const payments = document.createElement('div');

            payments.className = 'aveya-cart-payments';

            payments.dataset.aveyaPayments = '';

            payments.setAttribute('role', 'list');

            payments.setAttribute('aria-label', 'Moyens de paiement acceptés');

            for (const original of source.querySelectorAll('svg')) {

              const item = document.createElement('span');

              item.setAttribute('role', 'listitem');

              item.append(original.cloneNode(true));

              payments.append(item);

            }

            summary.append(payments);

          }

        }

        for (const svg of summary.querySelectorAll('[data-aveya-payments] svg')) {

          const title = svg.querySelector('title[id]');

          if (title) {

            title.id = `aveya-cart-${title.id}`;

            svg.setAttribute('aria-labelledby', title.id);

          }

        }

      }

      this.#updateStickyState();

    } finally {

      if (this.isConnected) this.#observeAveyaCart();

    }

  }



  #isCartEmpty() {

    return Boolean(this.querySelector('.cart-drawer--empty'));

  }



  #updateStickyState() {

    const dialog = this.#dialog;

    if (!dialog) return;



    // Refs do not cross nested `*-component` boundaries (e.g., `cart-items-component`), so we query within the dialog.

    const content = dialog.querySelector('.cart-drawer__content');

    const summary = dialog.querySelector('.cart-drawer__summary');



    if (!content || !summary) {

      // Ensure the dialog doesn't get stuck in "unsticky" mode when summary disappears (e.g., empty cart).

      dialog.setAttribute('cart-summary-sticky', 'false');

      return;

    }



    const drawerHeight = dialog.getBoundingClientRect().height;

    const summaryHeight = summary.getBoundingClientRect().height;

    const ratio = summaryHeight / drawerHeight;

    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');

  }

}



if (!customElements.get('cart-drawer-component')) {

  customElements.define('cart-drawer-component', CartDrawerComponent);

}
